import { Tag } from '@everlywell/ui-kit';
import React from 'react';

const TAG_DEFAULT_BACKGROUND_COLOR = 'tints.darkCream';
const TAG_DEFAULT_TEXT_COLOR = 'tints.darkGrey';

const tagColorMap: Record<
  string,
  {
    backgroundColor: string;
    textColor: string;
  }
> = {
  'supply available': {
    backgroundColor: 'viridian.lighter',
    textColor: TAG_DEFAULT_TEXT_COLOR,
  },
  'in stock': {
    backgroundColor: 'viridian.lighter',
    textColor: TAG_DEFAULT_TEXT_COLOR,
  },
  shortage: {
    backgroundColor: 'terracotta.lighter',
    textColor: TAG_DEFAULT_TEXT_COLOR,
  },
  sale: {
    backgroundColor: 'eggplant.base',
    textColor: TAG_DEFAULT_TEXT_COLOR,
  },
};

export type ProductTagProps = {
  displayText?: string | null;
  metadata?: Queries.ContentfulMetadata001 | null;
};

/**
 * ProductTag component
 * Component to display a tag with a background color and text color
 * @param props [ProductTagProps]
 * @returns JSX.Element
 */
const ProductTag = ({ displayText, metadata }: ProductTagProps) => {
  const tagText = displayText || '';
  const contentfulBackgroundColor = metadata?.theme?.backgroundColor;
  const contentfulTextColor = metadata?.theme?.textColor;

  // Check if contentfulColor is defined, if not, try to get the color from tagColorMap
  // If both are undefined, use the default color

  const localColorMap = tagColorMap[tagText.toLowerCase()];

  const tagBackgroundColor =
    contentfulBackgroundColor ||
    localColorMap?.backgroundColor ||
    TAG_DEFAULT_BACKGROUND_COLOR;

  const tagTextColor =
    contentfulTextColor || localColorMap?.textColor || TAG_DEFAULT_TEXT_COLOR;

  return (
    <Tag color={tagTextColor} backgroundColor={tagBackgroundColor}>
      {tagText}
    </Tag>
  );
};

export default ProductTag;
